import { sectionRenderer } from '@theme/section-renderer';

const blockedOptionValues = new Set(['manual', 'title-descending', 'created-ascending']);

// Covers iPhone/iPad/iPod and iPadOS in desktop mode.
const isIOS =
  /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

if (isIOS) {
  const removeBlockedOptions = (root = document) => {
    const scope = root instanceof Element || root instanceof Document ? root : document;
    const selects = scope.querySelectorAll('select.sorting-filter__select');

    selects.forEach((select) => {
      const currentValue = select.value;
      const shouldRestoreSelection = blockedOptionValues.has(currentValue);

      select.querySelectorAll('option').forEach((option) => {
        if (blockedOptionValues.has(option.value)) {
          option.remove();
        }
      });

      if (shouldRestoreSelection && select.options.length > 0) {
        select.selectedIndex = 0;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  };

  const originalRenderSection = sectionRenderer.renderSection.bind(sectionRenderer);

  sectionRenderer.renderSection = async function (...args) {
    const result = await originalRenderSection(...args);
    removeBlockedOptions();
    return result;
  };

  removeBlockedOptions();
}
